import {AttrList} from "../../../datas/OpClass";
import React, {useEffect, useState} from "react";
import {FxmsData} from "../../../datas/FxData";
import {FxWindow} from "../../../windows/FxWindows";
import FxLineChart from "../../../../vup/components/FxLineChart";
import {FxDataGrid} from "../../grid/FxDataGrid";
import {FxDataSearch} from "../../../inputs/FxDataSearch";
import { StyledEngineProvider } from "@mui/material/styles";
import '../Gadget.css'
import {GridDataSelecter} from "./GridDataSelecter";
import Select from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import {Button} from "@mui/material";
import { Input } from '@mui/material';
import Search from '@mui/icons-material/Search'
import {stringify} from "query-string";
import axios from "axios";
export const DataGrid = (props) => {

    const [rows, setRows] = useState([]);
    const [url, setUrl] = useState("vup/select_4_5")
    const [filter, setFilter] = useState(null);
    const [data, setData] = React.useState([]);
    const [columnList, setColumnList] = useState(null)
    const [filterParams, setFilterParams] = useState({})
    const [customColums, setCustomColumns] = useState({})
    //기본 필터 3종
    const [complex, setComplex] = useState([])
    const [plant, setPlant] = useState([])
    const [company, setCompany] = useState([])
    const [filterData ,setFilterData] = useState({})
    //기본 필터 선택됨
    const [selectedComplex, setSelectedComplex] = useState(0)
    const [selectedPlant, setSelectedPlant] = useState(0)
    const [selectedCompany, setSelectedCompany] = useState(0)
    //로딩
    const [loading, setLoading] = useState(false)
    useEffect(()=>{
        try {
                if(props.item.fxUiDashbItemAttrs){
                    if(props.item.fxUiDashbItemAttrs.length >= 2 ){
                        setLoading(true)
                        let params = {}
                        let savedUri = props.item.fxUiDashbItemAttrs.find(x=>x.attrName =='uri').attrVal
                        let savedColumns = JSON.parse(props.item.fxUiDashbItemAttrs.find(x=>x.attrName =='column').attrVal)
                        FxmsData.selectGridData(savedUri, params ).then(res=>{
                            const columnsList = new AttrList("grid");
                            res.data.map((x,index)=>{
                                x.id = index
                            })
                            let cols = []
                            let filters = {}
                            if(res.data.length > 0){
                                Object.keys(savedColumns).map(x=>{
                                    columnsList.addColumn(x,savedColumns[x].text,'text',200)
                                    if(x.search){
                                        let columnData = res.data.map(f => f[x])
                                        let uniqColumnData = columnData.filter((value, index, array) => array.indexOf(value) === index);
                                        filters[x] = {origin:x,alias:savedColumns[x].text,data:uniqColumnData}
                                    }
                                })
                            }
                            setFilterData(filters)
                            setColumnList(columnsList)
                            setUrl(savedUri)
                            setRows(res.data)
                            setLoading(false)
                        })
                    }

                }




            //기본 필터 데이터 가져오기
            // FxmsData.getSelectItemRt('inlo',{inloClCd:"COMPLEX"}).then(res=>{
            //     res.unshift({key:0,text:'산업단지전체',fxObject:{complexInloNo:0}})
            //     setComplex(res)
            // })
            // FxmsData.getSelectItemRt('inlo',{inloClCd:"COMPANY"}).then(res=>{
            //     res.unshift({key:0,text:'회사전체',fxObject:{companyInloNo:0}})
            //     setCompany(res)
            // })
            // FxmsData.getSelectItemRt('inlo',{inloClCd:"PLANT"}).then(res=>{
            //     res.unshift({key:0,text:'공장전체',fxObject:{plantInloNo:0}})
            //     setPlant(res)
            // })

        } catch (error) {
            console.log("error" + error);
           // FxWindow.alert("조회중 오류가 발행되었습니다.", true);
            setRows([]);
            setData([]);
        }
    },[])

    const selectGridData = (url, para, sortAttrName = "AAA", sortOrder = "ASC") => {
        let params = {};
        params.pagination = {};
        params.pagination.page = 1; // 첫 페이지
        params.pagination.perPage = 999999; // 999999건.
        params.filter = para;
        params.sort = {};
        params.sort.order = sortOrder;
        params.sort.field = sortAttrName;

        // 정의되지 않은 내용은 삭제한다.
        for (let key of Object.keys(para)) {
            if (para[key] === null || para[key] === "") {
                delete para[key];
            }
        }

        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;
        const query = {
            sort: JSON.stringify([field, order]),
            range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
            filter: JSON.stringify(params.filter),
        };
        const callUrl = `${url}?${stringify(query)}`;
        axios
            .get("/api/" + callUrl, FxmsData.getHeader())
            .then( (res) => {
                const columnsList = new AttrList("grid");
                res.data.map((x,index)=>{
                    x.id = index
                })
                setRows(res.data)
                setLoading(false)
            }).catch(err=>{
            alert("data error")
            setLoading(false)
        })
    }
    //on Save function
    const handleUriChange = (selectedUri,customColum,data) => {
        //db에 저장하는부분
        let currentData = []
        currentData.push({uiNo:props.item.uiNo,attrName:'uri',attrVal:selectedUri,attrType:'string'})
        currentData.push({uiNo:props.item.uiNo,attrName:'column',attrVal:JSON.stringify(customColum),attrType:'string'})
        props.save(currentData,props.item.uiNo,props.item.opId)

        const columnsList = new AttrList("grid");
        let filters = {}
        Object.keys(customColum).map(x=>{
            columnsList.addColumn(x,customColum[x].text,'text','100')
            if(x.search){
                let columnData = data.map(f => f[x])
                let uniqColumnData = columnData.filter((value, index, array) => array.indexOf(value) === index);
                filters[x] = {origin:x,alias:customColum[x].text,data:uniqColumnData}
            }
        })
        setFilterData(filters)
        setColumnList(columnsList)
        setUrl(selectedUri)
        setRows(data)

    }

    const removeItem = () => {
        props.removeItem(props.item.uiNo)
    }

    const handleComplexChange = (e) => {
        setSelectedComplex(e.target.value)
        setSelectedCompany(0)
        setSelectedPlant(0)
    }
    const handleCompanyChange = (e) => {
        setSelectedPlant(0)
        setSelectedCompany(e.target.value)
    }
    const handlePlantChange = (e) => {
        setSelectedPlant(e.target.value)
    }
    const handleFilterSelection = (e,name) => {
        if(e.target.value == ''){
            delete filterParams[name]
        }
        setFilterParams(prev=>({...prev,[name]:e.target.value}))
    }
    const handleSearch = () =>{
        selectGridData(url,filterParams)
    }
    return (
        <StyledEngineProvider>
            {/*<div className="GadgetFxCrudFilter">*/}
            {/*    <FxDataSearch*/}
            {/*    attrList={filter ? filter.getList() : []}*/}
            {/*    onChangeDatas={onChangeDatas}*/}
            {/*    inputType="Search"*/}
            {/*    />*/}
            {/*</div>*/}
            {loading ?
                <Box sx={{zIndex:9999, transform:'translate(-50%, -50%)',position:'fixed',top:'50%',left:'50%'}}><CircularProgress size={100} color='secondary' /></Box> : ''}
            <div style={{display:'block', justifyContent:'center',alignItems:'center'}} className="GadgetFxCrudFilter">

                {Object.keys(filterData).map(x=>{
                    return(
                        <FormControl sx={{margin:'15px'}} key={x}>
                            <InputLabel  >{filterData[x].alias}</InputLabel>
                            <Select
                                sx={{minWidth:'100px',color: "white", '.MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '&:hover .MuiOutlinedInput-notchedOutline': {borderColor: 'rgba(243,232,248,0.82)',},
                                    '.MuiSvgIcon-root ': {fill: "white !important",}
                                }}
                                fullWidth
                                dense
                                value={filterParams[x]}
                                defaultValue={''}
                                onChange={(e)=>{handleFilterSelection(e,x)}}
                                input={<OutlinedInput />}
                            >
                                <MenuItem className="dashboard_admin_select"  key={'init0'} value={''}>전체선택</MenuItem>
                                {filterData[x].data.map((y) => {
                                    return <MenuItem className="dashboard_admin_select"  key={y} value={y}>{y}</MenuItem>
                                })}
                            </Select>
                        </FormControl>
                    )
                })}
                <label style={{fontSize:'x-small'}}>
                    Start<br/>
                    <Input
                        placeholder={"Start"}
                        className="FxDateTime"
                        type="date" name="Start"
                        style={{width:'140px',height:'43px'}}
                        onChange={(e)=>{handleFilterSelection(e,'sDate')}}
                    />
                </label>
                <label style={{fontSize:'x-small'}}>
                    End<br/>
                    <Input
                        placeholder={"End"}
                        className="FxDateTime"
                        type="date" name="End"
                        style={{width:'140px',height:'43px'}}
                        onChange={(e)=>{handleFilterSelection(e,'eDate')}}
                    />
                </label>
                <Button style={{height:'50px'}} variant={"contained"} onClick={()=>{handleSearch();console.log(filterParams)}}><Search/></Button>
            </div>
            <div className="FxCrudDataGrid" style={{minHeight: "230px"}}>
                {props.editable ? <GridDataSelecter uri={url} handleUriChange={handleUriChange} customColumns={setCustomColumns} removeItem={removeItem}/>: '' }
                <FxDataGrid
                    attrList={columnList ? columnList.getList() : []}
                    rows={rows}
                    height={"410px"}
                    menuFullName={props.item.menuFullName}
                />
            </div>
            <footer>
                <div>Virtual Utility Plant</div>
                <div>Copyright 2022 VUP All rights reserved</div>
            </footer>
        </StyledEngineProvider>
    )
}